<template>
  <div>
    <router-view
      ref="feedInfo"
      :key="$route.fullPath.replace('#top', '')"
    ></router-view>
    <DataViewVue
      ref="dataView"
      @updateStatistics="updateStatistics"
      @likeFunc="likeFunc"
      @collectFunc="collectFunc"
      @reportFunc="reportFunc"
      @deleteFunc="deleteFunc"
      @key="key"
    ></DataViewVue>
    <ReportVue ref="report"></ReportVue>
  </div>
</template>

<script>
import CreateFeedVue from "./CreateFeed.vue";
import UserFeedInfoVue from "./UserFeedInfo.vue";
import ReportVue from "../common/Report.vue";
import DataViewVue from "./DataView.vue";
import bases from "../../api/httpApi/base";
import socialTool from "../../assets/js/socialJs/tool";
export default {
  components: {
    UserFeedInfoVue,
    CreateFeedVue,
    ReportVue,
    DataViewVue,
  },
  data() {
    return {
      currentItem: "feed",
      currentPlayer: null,
      shareurl: `${this.$shareUrl}${bases.url}/Home/facebookResp`,
      playerOptions: {},
      noChangeVideoList: [],
    };
  },
  provide() {
    return {
      root_getSingleData: this.getSingleData,
      root_shareurl: this.shareurl,
      root_collectFunc: this.collectFunc,
      root_reportFunc: this.reportFunc,
      root_deleteFunc: this.deleteFunc,
      root_onPlayerPlay: this.onPlayerPlay,
      root_likeFunc: this.likeFunc,
      root_submitComment: this.submitComment,
      root_updateStatistics: this.updateStatistics,
      root_shareurl: this.shareurl,
      root_viewInfo: this.viewInfo,
      root_qryComment: this.qryComment,
      root_copyLink: this.copyLink,
    };
  },
  methods: {
    changeShow(item) {
      let params = {
        id: item.id,
        sgL_IsShow: item.sgL_IsShow,
      };
      this.$api.social.UpdateStat(params).then((res) => {
        if (res.data.success) {
          item.sgL_IsShow = !item.sgL_IsShow;
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    checkIsCert() {
      if (this.checkUser()) {
        //判断是否已认证
        if (
          !this.IsNullOrEmpty(this.loginUser) &&
          !this.loginUser.sgL_IsCheck
        ) {
          //跳转到认证页面
          this.$router.push({
            name: "certification",
            query: { redirect: this.$route.fullPath },
          });
          return;
        } else {
          this.$router.push({
            name: "SocialVideoUpload",
          });
        }
      }
    },
    changeItem(n) {
      this.currentItem = n;
    },
    copyLink(id) {
      this.copyToClipboard(socialTool.copyLink(id), true);
    },
    async getSingleData(id, viewType, isShow) {
      let params = {
        id,
      };
      let singleData = null;
      await this.$api.social.GetSingleSocialData(params).then((res) => {
        if (res.data.success) {
          singleData = res.data.result;
          if (isShow) {
            this.viewInfo(res.data.result, viewType);
          }
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
      return singleData;
    },
    checkUser() {
      let result = false;
      if (this.loginUser == null) {
        this.$refs.dataView.hideWindow();
        this.$router.push({
          path: "/customerLogin",
          query: { redirect: this.$route.fullPath },
        });
        return;
      } else {
        result = true;
      }
      return result;
    },
    collectFunc(item) {
      if (this.checkUser()) {
        socialTool.addfavorite(0, item);
      }
    },
    reportFunc(item) {
      if (this.checkUser()) {
        //this.$refs.report.init(item.id, item.sgL_UsersName, 5, null);
        socialTool.reportFunc.call(this, item);
      }
    },
    deleteFunc(item) {
      if (this.checkUser()) {
        this.$confirm("刪除後無法復原,確認刪除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              id: item.id,
            };
            this.$api.social.DeleteSocialData(params).then((res) => {
              if (res.data.success) {
                this.$refs.feedInfo.getPageData();
                this.$refs.dataView.hideWindow();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.error.message,
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    onPlayerPlay(player, index) {
      console.log('播放');
      console.log(index);
      if (this.currentPlayer && this.currentPlayer != player) {
        this.currentPlayer.pause();
      }
      this.currentPlayer = player;
    },
    likeFunc(item, isadd) {
      if (this.checkUser()) {
        socialTool.addfavorite(1, item, !isadd);
      }
    },
    async qryComment(item) {
      let params = {
        SGL_PG_Coid: item.id,
        SGL_Msg_Type: 7,
      };
      if(item.sgL_GroupId){
        params.SGL_PG_Coid = item.sgL_GroupId,
        params.SGL_Msg_Belongidc = item.id
      }
      let commentData = null;
      await this.$api.albumApi.getMessageByTypeId(params).then((res) => {
        if (res.data.success) {
          item.sgL_PG_CTotalMesg = res.data.result.totalCount;
          commentData = res.data.result.items;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
      return commentData;
    },
    submitComment(item, content, callBack) {
      let params = {
        sgL_PG_CBigsort: 2,
        sgL_PG_Coid: item.id,
        sgL_Msg_Type: 7,
        sgL_Msg_MContent: content,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: item.sgL_UserID,
      };
      if(item.sgL_GroupId){
        params.sgL_PG_Coid = item.sgL_GroupId;
        params.SGL_Msg_Belongidc = item.id;
      }
      this.submitBaseComment(item, params, callBack);
    },
    submitComment2(
      item,
      content,
      callBack,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_Reply_Cid
    ) {

      let params = {
        sgL_PG_CBigsort: 2,
        sgL_PG_Coid: item.id,
        sgL_Msg_Type: 7,
        sgL_Msg_MContent: content,
        sgL_Msg_SendType: 1,
        SGL_Mem_FinallyReceive_Cid: item.sgL_UserID,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
      };
       if (item.sgL_GroupId) {
        params.sgL_PG_Coid = item.sgL_GroupId;
        params.SGL_Msg_Belongidc = item.id;
      }
      this.submitBaseComment(item, params, callBack);
    },
    submitBaseComment(item, params, callBack) {
      if (this.checkUser()) {
        if (params.sgL_Msg_MContent == "") {
          this.$message({ type: "warning", message: "內容不能為空" });
          return;
        }
        this.$api.albumApi.createMessage(params).then((res) => {
          if (res.data.success) {
            if (callBack) {
              callBack(item);
            }
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        });
      }
    },
    updateStatistics(item, type) {
      socialTool.updateStatistics(item, type);
    },
    viewInfo(item, viewType) {
      let fileUrl = item.fileShareUrl;
      if (!this.IsNullOrEmpty(viewType) && viewType == "share") {
        fileUrl = item.fileShareUrl;
      }
      let poster = item.jietuFileUrl;
      if (!this.IsNullOrEmpty(item.sgL_ImageTempURL)) {
        poster = item.sgL_ImageTempURL;
      }
      let dataView = this.$refs.dataView;
      dataView.clear();
      if (item.sgL_Type == 0) {
        dataView.setPlayerOptionToUrl(fileUrl, poster);
      }
      dataView.setData(item);
      this.qryComment(item).then((data) => {
        dataView.setcommentData(data);
      });
      dataView.showWindow();
    },
    key(event, item, commentText) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        this.submitComment(item, commentText, this.keyCallBack);
      }
    },
    keyCallBack(item) {
      this.qryComment(item).then((data) => {
        let dataView = this.$refs.dataView;
        dataView.setcommentData(data);
        dataView.clearCommentText();
      });
    },
    addfavorite(sgL_DevicesType, item, isadd) {
      let params = {
        sgL_DevicesType: sgL_DevicesType,
        sgL_MasterSort: item.sgL_Type, //类型
        sgL_PG_Coid: item.id, //图册、影片、文章、活动的id
        sgL_Fav_FType: 5, //图册：0，图片：1，影片：2,活动：3，新闻文字Id：4，社区：5
        sgL_Fav_FBelongidc: null,
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          if (sgL_DevicesType == 0) {
            item.sgL_IsFavorite = !item.sgL_IsFavorite;
          } else if (sgL_DevicesType == 1) {
            if (isadd) {
              item.sgL_PG_CTotalLike++;
            } else {
              if (item.sgL_PG_CTotalLike > 0) {
                item.sgL_PG_CTotalLike--;
              }
            }
            item.sgL_IsLike = !item.sgL_IsLike;
          } else if (sgL_DevicesType == 3) {
            item.sgL_IsImpeach = !item.sgL_IsImpeach;
          }
        }
      });
    },
    saveFeed(data1, data2, data3,sgL_IsShow, width, height, fn) {
      if (this.checkUser()) {
        let params = {
          sgL_ImageTempId: data1,
          sgL_Content: data2,
          sgL_Type: data3,
          sgL_IsShow,
          width,
          height,
        };
        this.$api.social.CreateSocialData(params).then((res) => {
          if (res.data.success) {
            this.$refs.feedInfo.getPageData(true);
            if (fn) {
              fn();
            }
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Social/FeedHome.vue